import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4b014fec"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "export-pdf-dialog" }
const _hoisted_2 = { class: "thumbnails-view" }
const _hoisted_3 = { class: "configs" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "title" }
const _hoisted_6 = { class: "radio-list" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "title" }
const _hoisted_9 = {
  class: "row",
  style: {"justify-content":"space-between"}
}
const _hoisted_10 = { class: "title" }
const _hoisted_11 = { class: "tip" }
const _hoisted_12 = { class: "btns" }

import { ref, h } from "vue";
import { storeToRefs } from "pinia";
import { useSlidesStore } from "@/store";
import { print } from "@/utils/print";
import { useI18n } from "vue-i18n";
import { saveClickData } from "@/api/combo";
import Cookies from "js-cookie";
import { sendClickData } from "@/utils/common";
import { event } from 'vue-gtag';
import ThumbnailSlide from "@/views/components/ThumbnailSlide/index.vue";
import { Button, Select, Switch, Radio, notification } from "ant-design-vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ExportPDF',
  emits: ["close"],
  setup(__props, { emit }: { emit: ({
  (event: "close"): void;
}), expose: any, slots: any, attrs: any }) {

const { t, locale } = useI18n();

const { Group: RadioGroup, Button: RadioButton } = Radio;
const SelectOption = Select.Option;



const { slides, currentSlide, viewportRatio } = storeToRefs(useSlidesStore());

const pdfThumbnailsRef = ref<HTMLElement>();
const rangeType = ref<"all" | "current">("all");
const count = ref(1);
const padding = ref(true);

const expPDF = () => {
  const equipmentType = sessionStorage.getItem("equipmentType");
  if (equipmentType === "extension") {
    notification.open({
      message: t(`public.systemMsg`),
      description: t(`extension.nonsupportDownloadPDF`),
    });
    return;
  } else if (equipmentType === "mac" || equipmentType === "win") {
    notification.open({
      message: t(`public.systemMsg`),
      description: t(`desktop.unSupportPreviewPDF`),
      duration: null,
    });
  }
  setTimeout(() => {
    desktopPrint();
  }, 500);
};
const desktopPrint = () => {
  if (!pdfThumbnailsRef.value) return;
  event('ppt_download')
  // sendClickData type = 18
  sendClickData(18, 18, "", "");
  const pageSize = {
    width: 1600,
    height:
      rangeType.value === "all"
        ? 1600 * viewportRatio.value * count.value
        : 1600 * viewportRatio.value,
    margin: padding.value ? 50 : 0,
  };
  print(pdfThumbnailsRef.value, pageSize);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "thumbnails",
        ref_key: "pdfThumbnailsRef",
        ref: pdfThumbnailsRef
      }, [
        (rangeType.value === 'current')
          ? (_openBlock(), _createBlock(ThumbnailSlide, {
              key: 0,
              class: "thumbnail",
              slide: _unref(currentSlide),
              size: 1600
            }, null, 8, ["slide"]))
          : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_unref(slides), (slide, index) => {
              return (_openBlock(), _createBlock(ThumbnailSlide, {
                class: _normalizeClass(["thumbnail", { 'break-page': (index + 1) % count.value === 0 }]),
                key: slide.id,
                slide: slide,
                size: 1600
              }, null, 8, ["class", "slide"]))
            }), 128))
      ], 512)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t(`editor.exportDialog.exportScope`)) + "： ", 1),
        false
          ? (_openBlock(), _createBlock(_unref(RadioGroup), {
              key: 0,
              class: "config-item",
              value: rangeType.value,
              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((rangeType).value = $event))
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(RadioButton), {
                  style: {"width":"50%"},
                  class: "type-btn",
                  value: "all"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t(`editor.exportDialog.exportPdf.all`)), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_unref(RadioButton), {
                  style: {"width":"50%"},
                  class: "type-btn",
                  value: "current"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t(`editor.exportDialog.exportPdf.thisPage`)), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["value"]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", {
            class: _normalizeClass(['radio-item', { 'radio-active': rangeType.value === 'all' }]),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (rangeType.value = 'all'))
          }, _toDisplayString(_ctx.$t(`editor.exportDialog.exportPdf.all`)), 3),
          _createElementVNode("div", {
            class: _normalizeClass(['radio-item', { 'radio-active': rangeType.value === 'current' }]),
            onClick: _cache[2] || (_cache[2] = ($event: any) => (rangeType.value = 'current'))
          }, _toDisplayString(_ctx.$t(`editor.exportDialog.exportPdf.thisPage`)), 3)
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t(`editor.exportDialog.exportPdf.pageNum`)) + "： ", 1),
        _createVNode(_unref(Select), {
          class: "selection",
          value: count.value,
          "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((count).value = $event))
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(SelectOption), { value: 1 }, {
              default: _withCtx(() => [
                _createTextVNode("1")
              ]),
              _: 1
            }),
            _createVNode(_unref(SelectOption), { value: 2 }, {
              default: _withCtx(() => [
                _createTextVNode("2")
              ]),
              _: 1
            }),
            _createVNode(_unref(SelectOption), { value: 3 }, {
              default: _withCtx(() => [
                _createTextVNode("3")
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["value"])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t(`editor.exportDialog.exportPdf.white`)) + "： ", 1),
        _createElementVNode("div", null, [
          _createVNode(_unref(Switch), {
            checked: padding.value,
            "onUpdate:checked": _cache[4] || (_cache[4] = ($event: any) => ((padding).value = $event))
          }, null, 8, ["checked"])
        ])
      ]),
      _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t(`editor.exportDialog.exportPdf.notice`)), 1)
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createVNode(_unref(Button), {
        class: "btn close",
        onClick: _cache[5] || (_cache[5] = ($event: any) => (emit('close')))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t(`editor.exportDialog.close`)), 1)
        ]),
        _: 1
      }),
      _createVNode(_unref(Button), {
        class: "btn export",
        type: "primary",
        onClick: _cache[6] || (_cache[6] = ($event: any) => (expPDF()))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t(`editor.exportDialog.expPdf`)), 1)
        ]),
        _: 1
      })
    ])
  ]))
}
}

})